var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnergyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.615 0.595102C12.7614 0.676599 12.8763 0.804783 12.9413 0.959206C13.0064 1.11363 13.0179 1.28539 12.974 1.4471L10.982 8.7501H18.25C18.3961 8.75011 18.5391 8.79283 18.6613 8.873C18.7835 8.95317 18.8796 9.06731 18.9378 9.20138C18.9961 9.33544 19.0138 9.4836 18.989 9.62763C18.9641 9.77167 18.8977 9.9053 18.798 10.0121L8.29795 21.2621C8.18359 21.3849 8.03135 21.4658 7.86558 21.4919C7.69981 21.5179 7.53009 21.4876 7.38357 21.4058C7.23704 21.3241 7.12218 21.1955 7.05735 21.0407C6.99252 20.8859 6.98146 20.7139 7.02595 20.5521L9.01795 13.2501H1.74995C1.60379 13.2501 1.46082 13.2074 1.33861 13.1272C1.2164 13.047 1.12028 12.9329 1.06206 12.7988C1.00384 12.6648 0.986069 12.5166 1.01092 12.3726C1.03578 12.2285 1.10217 12.0949 1.20195 11.9881L11.702 0.738102C11.8163 0.615748 11.9683 0.535195 12.1338 0.509279C12.2993 0.483363 12.4687 0.513576 12.615 0.595102Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyIcon);
export default __webpack_public_path__ + "static/media/energyIcon.5519e28d9b51a0d9dcac8a7be3b6a316.svg";
export { ForwardRef as ReactComponent };